export default "__VITE_ASSET__8cb97f64__"